module.exports = __webpack_public_path__ + "img/ReferAndEarn.76fe7c68.svg";